import React, { useState } from "react";
import { cn } from "../../../lib/utils";
import CrmPopover from "../ui/CrmPopover";
import { FOCUS_RING } from "../ui/classes";

/**
 * One filter of the Clients filter bar (wireframe): outlined while it holds its default,
 * filled ink with "Label: Value ▾" once set — the admin's filter-tab treatment. Opens a small list — checkboxes for
 * a multi-select, radios for a dropdown.
 *
 * `options`: `[{value, label}]`; `value`: an array (multi) or a string ("" = default).
 */
export default function FilterChip({ label, summary, multi = false, options, value, onChange, active, testId, optionTestId }) {
  const [open, setOpen] = useState(false);
  const selected = multi ? value : [value];
  const toggle = (v) => {
    if (multi) onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
    else { onChange(v); setOpen(false); }
  };
  return (
    <CrmPopover
      open={open}
      onOpenChange={setOpen}
      className="w-64 p-2"
      trigger={(
        <button type="button" data-testid={testId} data-active={active ? "true" : "false"} aria-haspopup="dialog"
          title={summary}
          className={cn(
            "inline-flex max-w-[18rem] items-center gap-1 truncate rounded-full px-3 py-1 text-xs transition-colors", FOCUS_RING,
            active ? "border border-eh-ink bg-eh-ink text-eh-bg" : "border border-eh-border-soft bg-white text-eh-ink hover:bg-eh-bg",
          )}>
          <span className="truncate">{summary}</span>
          <span aria-hidden="true" className="text-[10px]">▾</span>
        </button>
      )}
    >
      <fieldset>
        <legend className="px-2 pb-1 text-xs font-semibold uppercase tracking-wider text-eh-muted">{label}</legend>
        <ul className="max-h-64 overflow-y-auto" data-lenis-prevent>
          {options.map((o) => {
            const on = selected.includes(o.value);
            return (
              <li key={String(o.value)}>
                <label className="flex cursor-pointer items-center gap-2 rounded-xl px-2 py-1.5 text-sm text-eh-ink hover:bg-eh-cream">
                  <input
                    type={multi ? "checkbox" : "radio"}
                    name={multi ? undefined : testId}
                    checked={on}
                    onChange={() => toggle(o.value)}
                    data-testid={optionTestId ? optionTestId(o.value === "" ? "any" : o.value) : undefined}
                    className="h-4 w-4 accent-eh-sage-deep"
                  />
                  {o.label}
                </label>
              </li>
            );
          })}
        </ul>
      </fieldset>
    </CrmPopover>
  );
}
